import { GQL } from "../api/gql/index"

export enum Group {
  Admins = "Admins",
  HRPros = "HRPros",
  HRProManagers = "HRProManagers",
  TechnicalInterviewers = "TechnicalInterviewers",
  SoftSkillInterviewers = "SoftSkillInterviewers",
  Clients = "Clients",
  BackOffice = "BackOffice",
}
export const allGroups: Group[] = Object.keys(Group) as Group[]

// JWT custom claim prefix
export const CUSTOM_CLAIM_PREFIX = "tmbo:"

// JWT claim field that contains user's groups
export const CLAIM_GROUPS = CUSTOM_CLAIM_PREFIX + "groups"
export const CLAIM_USER_ID = CUSTOM_CLAIM_PREFIX + "tmboUserId"
export const CLAIM_TENANT_ID = CUSTOM_CLAIM_PREFIX + "tenantId"

export const groupDisplayNames: Record<Group, string> = {
  [Group.BackOffice]: "Back Office",
  [Group.Admins]: "Super Admin",
  [Group.HRProManagers]: "Admin",
  [Group.HRPros]: "Sourcer",
  [Group.SoftSkillInterviewers]: "Recruiter",
  [Group.TechnicalInterviewers]: "Supervisor",
  [Group.Clients]: "Client",
}

/**
 * Get a simple summary of the groups a user belongs to.
 * E.g. 'Manager', 'Technical Interviewer', etc
 */
export function groupsToDisplayName(groups: Group[]): string {
  if (!groups || !groups.length) return "None"

  // return name of highest group
  if (groups.includes(Group.Admins)) return getGroupDisplayName(Group.Admins)
  if (groups.includes(Group.HRProManagers)) return getGroupDisplayName(Group.HRProManagers)
  if (groups.includes(Group.HRPros)) return getGroupDisplayName(Group.HRPros)
  if (groups.includes(Group.TechnicalInterviewers)) return getGroupDisplayName(Group.TechnicalInterviewers)
  if (groups.includes(Group.SoftSkillInterviewers)) return getGroupDisplayName(Group.SoftSkillInterviewers)
  if (groups.includes(Group.Clients)) return getGroupDisplayName(Group.Clients)

  return "None"
}

export function getGroupDisplayName(group: Group): string {
  return groupDisplayNames[group]
}

export type AuthContextUser = GQL.AuthenticationContextQuery["getUser"]
